{
    "Components": {
        "Alert": {
            "ariaLabel": "Sluiten",
            "endChatError": "Kan sessie niet beëindigen. Probeer het opnieuw.",
            "sessionEnded": "Je sessie is beëindigd. Je bent doorgestuurd naar de startpagina.",
            "networkError": "Er is een probleem opgetreden bij het verbinden met je sessie. Probeer het opnieuw.",
            "messageError": "Sorry, our chat assistant is currently unavailable. Please use <a href='https://ring.com/support'>Ring Help</a> for help resources or try again in a few minutes.",
            "messageLabel": "Waarschuwing"
        },
        "Body": {
            "latestMessage": "Laatste berichten",
            "loadMessages": "Berichten laden",
            "newMessage": "Nieuw bericht",
            "title": "Hoe kunnen we je helpen?",
            "subtitle": "Hallo. Ik ben een assistent van de Ring-klantenservice. Hoe kan ik je vandaag helpen?"
        },
        "Bubble": {
            "ariaLabel": "Chatbericht",
            "sourceTitle": "Handige koppelingen"
        },
        "Event": {
            "defaultJoin": "Een Ring-medewerker neemt nu deel aan de livechat.",
            "customerJoin": "Overgegaan naar livechat.",
            "agentJoin": "neemt nu deel aan de livechat.",
            "defaultLeft": "De Ring-medewerker heeft de livechat verlaten.",
            "customerLeft": "Je hebt de chat verlaten.",
            "agentLeft": "heeft de livechat verlaten.",
            "idle": "Je hebt al een tijdje niets van je laten horen. Laat je ons weten of we nog kunnen helpen?",
            "idleContinue": "Ik ben er nog, ik heb nog wat meer tijd nodig",
            "idleEnd": "Chat beëindigen",
            "returned": "Welkom terug! Laten we het gesprek voortzetten."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Duim omhoog",
            "ariaLabelThumbsDown": "Duim omlaag",
            "header": "Was dit nuttig?",
            "sent": "Bedankt voor je feedback",
            "thumbsDown": "Het spijt me dat mijn antwoord je niet heeft geholpen. Ik hoor graag je feedback zodat ik betere antwoorden kan geven.",
            "thumbsDownResponse": "Bedankt voor je feedback. Probeer je vraag anders te formuleren.",
            "thumbsUp": "Ik ben blij dat ik je heb kunnen helpen! Laat het me weten als er nog iets anders is waar ik mee kan helpen.",
            "RESPONSE_UNCLEAR": "Onduidelijk antwoord",
            "ISSUE_UNRESOLVED": "Geen oplossing voor mijn probleem",
            "NOT_HELPFUL": "Niet nuttig"
        },
        "Footer": {
            "ariaLabel": "Versturen",
            "placeholder": "Stel een korte vraag...",
            "subtext": "Deze chatbot maakt gebruik van generatieve AI om je vragen te beantwoorden. Controleer belangrijke informatie van deze antwoorden voordat je hier iets mee doet."
        },
        "Header": {
            "ariaLabelMenu": "Menu Meer",
            "ariaLabelMinimize": "Minimaliseren",
            "badgeTitle": "BÈTA",
            "badgeDisabled": "Verbinding verbroken",
            "themeLabel": "Thema",
            "muteLabel": "Stom",
            "unmuteLabel": "Dempen opheffen",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Beëindig de chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Sluiten",
            "ariaLabelOpen": "Openen",
            "notification": "Nieuw bericht",
            "expand": "Klik om uit te vouwen"
        },
        "WidgetIcon": {
            "ariaLabel": "Chat voor ondersteuning"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimaliseren",
            "button": "Chat starten",
            "title": "Bedankt dat je contact hebt opgenomen met Ring.",
            "subtitleHtml": "Door verder te gaan, ga je akkoord met de <a href='https://ring.com/terms'>servicevoorwaarden van Ring</a>. Informatie met betrekking tot deze chat kan worden verzameld en opgenomen. Zie onze <a href='https://ring.com/privacy-notice'>Privacyverklaring</a> voor meer informatie.",
            "loading": "Chat starten...",
            "error": "Kan sessie niet starten. Probeer het opnieuw.",
            "messageLabel": "Welkomsttekst"

        }
    }
}
